// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Google Sheets Import Component Styles */
.google-sheets-import {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  margin: 20px 0;
}

/* Header Section */
.import-header {
  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
  color: white;
  padding: 24px;
  text-align: center;
}

.import-header h2 {
  margin: 0 0 8px 0;
  font-size: 1.8rem;
  font-weight: 600;
}

.import-description {
  margin: 0;
  opacity: 0.9;
  font-size: 1rem;
  line-height: 1.5;
}

/* Form Container */
.import-form-container {
  padding: 32px;
}

.import-form {
  margin-bottom: 32px;
}

/* Form Section */
.form-section {
  background: #f8fafc;
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 24px;
}

.form-section h3 {
  margin: 0 0 20px 0;
  color: #2d3748;
  font-size: 1.2rem;
  font-weight: 600;
  border-bottom: 2px solid #e2e8f0;
  padding-bottom: 8px;
}

/* Form Groups */
/* Form Groups - Now using global styles from design-system.css */

.form-help {
  margin: 6px 0 0 0;
  font-size: 0.85rem;
  color: #718096;
  line-height: 1.4;
}

/* Checkbox Groups */
.checkbox-group {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-weight: 500;
  color: #2d3748;
}

.checkbox-input {
  width: 18px;
  height: 18px;
  accent-color: #0D3B66;
  cursor: pointer;
}

.checkbox-text {
  font-size: 0.95rem;
}

/* Form Actions */
.form-actions {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  justify-content: center;
  padding: 24px 0;
  border-top: 1px solid #e2e8f0;
}

.action-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  min-width: 160px;
}

.action-description {
  font-size: 0.875rem;
  color: #6b7280;
  text-align: center;
  margin: 0;
  line-height: 1.4;
}

/* Buttons */
.btn {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 140px;
  justify-content: center;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

.btn-primary {
  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
  color: white;
  box-shadow: 0 4px 8px rgba(102, 126, 234, 0.3);
  border: 2px solid transparent;
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
}

.btn-outline {
  background: #ffffff;
  color: #0D3B66;
  border: 2px solid #0D3B66;
  box-shadow: 0 2px 8px rgba(13, 59, 102, 0.2);
}

.btn-outline:hover:not(:disabled) {
  background: #0D3B66;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.btn-warning {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
  box-shadow: 0 4px 8px rgba(245, 158, 11, 0.3);
  border: 2px solid transparent;
}

.btn-warning:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(245, 158, 11, 0.4);
}

/* Import Result */
.import-result {
  background: #f8fafc;
  border-radius: 8px;
  padding: 24px;
  margin-top: 24px;
  border-left: 4px solid #e2e8f0;
}

.import-result.success {
  border-left-color: #48bb78;
  background: #f0fff4;
}

.import-result.error {
  border-left-color: #f56565;
  background: #fff5f5;
}

.result-header h3 {
  margin: 0 0 8px 0;
  font-size: 1.3rem;
  font-weight: 600;
}

.result-message {
  margin: 0 0 16px 0;
  color: #4a5568;
  font-size: 1rem;
  line-height: 1.5;
}

.result-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin: 12px 0;
  padding: 12px;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 6px;
}

.meta-item {
  font-size: 0.875rem;
  color: #6b7280;
}

.meta-item strong {
  color: #2d3748;
}

.preview-note {
  margin-top: 16px;
  padding: 12px;
  background: #e6fffa;
  border: 1px solid #81e6d9;
  border-radius: 6px;
  color: #234e52;
}

.preview-note p {
  margin: 0;
  font-size: 0.875rem;
}

/* Result Stats */
.result-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.stat-label {
  font-size: 0.85rem;
  color: #718096;
  margin-bottom: 4px;
  font-weight: 500;
}

.stat-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2d3748;
}

.stat-value.imported {
  color: #48bb78;
}

.stat-value.updated {
  color: #3182ce;
}

.stat-value.skipped {
  color: #ed8936;
}

/* Result Errors */
.result-errors {
  margin-top: 20px;
}

.result-errors h4 {
  margin: 0 0 12px 0;
  color: #e53e3e;
  font-size: 1.1rem;
  font-weight: 600;
}

.result-errors ul {
  margin: 0;
  padding-left: 20px;
}

.error-item {
  color: #c53030;
  margin-bottom: 8px;
  font-size: 0.9rem;
  line-height: 1.4;
}

/* Result Details */
.result-details {
  margin-top: 20px;
}

.result-details h4 {
  margin: 0 0 16px 0;
  color: #2d3748;
  font-size: 1.1rem;
  font-weight: 600;
}

.details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.detail-item {
  background: white;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.detail-item h5 {
  margin: 0 0 12px 0;
  color: #2d3748;
  font-size: 1rem;
  font-weight: 600;
  text-transform: capitalize;
}

.detail-stats {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}

.detail-stat {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
}

.detail-label {
  font-size: 0.875rem;
  color: #6b7280;
}

.detail-value {
  font-weight: 600;
  font-size: 0.875rem;
}

.detail-value.imported {
  color: #10b981;
}

.detail-value.updated {
  color: #3b82f6;
}

.detail-value.skipped {
  color: #f59e0b;
}

.detail-value.total {
  color: #6b7280;
}

.detail-errors {
  margin-top: 8px;
  padding: 8px;
  background: #fef2f2;
  border-radius: 4px;
  border: 1px solid #fecaca;
}

.detail-errors strong {
  color: #dc2626;
  font-size: 0.875rem;
}

.detail-errors ul {
  margin: 4px 0 0 0;
  padding-left: 16px;
}

.detail-error {
  font-size: 0.8rem;
  color: #dc2626;
  margin: 2px 0;
}

/* Import Info */
.import-info {
  background: #f7fafc;
  padding: 24px;
  border-top: 1px solid #e2e8f0;
}

.import-info h3 {
  margin: 0 0 20px 0;
  color: #2d3748;
  font-size: 1.2rem;
  font-weight: 600;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
}

.info-item {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.info-item h4 {
  margin: 0 0 12px 0;
  color: #2d3748;
  font-size: 1rem;
  font-weight: 600;
}

.info-item ul {
  margin: 0;
  padding-left: 20px;
}

.info-item li {
  margin-bottom: 8px;
  color: #4a5568;
  font-size: 0.9rem;
  line-height: 1.4;
}

.info-item strong {
  color: #2d3748;
  font-weight: 600;
}

/* Responsive Design */
@media (max-width: 768px) {
  .google-sheets-import {
    margin: 16px 0;
  }

  .import-header {
    padding: 20px;
  }

  .import-header h2 {
    font-size: 1.5rem;
  }

  .import-form-container {
    padding: 20px;
  }

  .form-section {
    padding: 16px;
  }

  .form-actions {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }

  .action-group {
    min-width: auto;
  }

  .btn {
    width: 100%;
    margin-bottom: 8px;
  }

  .result-stats {
    grid-template-columns: 1fr;
  }

  .details-grid {
    grid-template-columns: 1fr;
  }

  .info-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .import-header {
    padding: 16px;
  }

  .import-form-container {
    padding: 16px;
  }

  .form-section {
    padding: 12px;
  }

  .import-info {
    padding: 16px;
  }
}

/* Loading States */
.btn:disabled {
  position: relative;
  overflow: hidden;
}

.btn:disabled::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  animation: loading 1.5s infinite;
}

@keyframes loading {
  0% {
    left: -100%;
  }

  100% {
    left: 100%;
  }
}

/* Focus States for Accessibility */
.form-select:focus,
.checkbox-input:focus,
.btn:focus {
  outline: 2px solid #0D3B66;
  outline-offset: 2px;
}

/* Print Styles */
@media print {
  .google-sheets-import {
    box-shadow: none;
    border: 1px solid #e2e8f0;
  }

  .form-actions {
    display: none;
  }

  .import-result {
    page-break-inside: avoid;
    break-inside: avoid;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/googleSheets/GoogleSheetsImport.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB,iEAAiE;;AAEjE;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,8CAA8C;EAC9C,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,6CAA6C;EAC7C,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,cAAc;EACd,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,gCAAgC;AAClC;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,mCAAmC;AACnC;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wBAAmB;IAAnB,mBAAmB;EACrB;AACF","sourcesContent":["/* Google Sheets Import Component Styles */\n.google-sheets-import {\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  overflow: hidden;\n  margin: 20px 0;\n}\n\n/* Header Section */\n.import-header {\n  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n  color: white;\n  padding: 24px;\n  text-align: center;\n}\n\n.import-header h2 {\n  margin: 0 0 8px 0;\n  font-size: 1.8rem;\n  font-weight: 600;\n}\n\n.import-description {\n  margin: 0;\n  opacity: 0.9;\n  font-size: 1rem;\n  line-height: 1.5;\n}\n\n/* Form Container */\n.import-form-container {\n  padding: 32px;\n}\n\n.import-form {\n  margin-bottom: 32px;\n}\n\n/* Form Section */\n.form-section {\n  background: #f8fafc;\n  border-radius: 8px;\n  padding: 24px;\n  margin-bottom: 24px;\n}\n\n.form-section h3 {\n  margin: 0 0 20px 0;\n  color: #2d3748;\n  font-size: 1.2rem;\n  font-weight: 600;\n  border-bottom: 2px solid #e2e8f0;\n  padding-bottom: 8px;\n}\n\n/* Form Groups */\n/* Form Groups - Now using global styles from design-system.css */\n\n.form-help {\n  margin: 6px 0 0 0;\n  font-size: 0.85rem;\n  color: #718096;\n  line-height: 1.4;\n}\n\n/* Checkbox Groups */\n.checkbox-group {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-weight: 500;\n  color: #2d3748;\n}\n\n.checkbox-input {\n  width: 18px;\n  height: 18px;\n  accent-color: #0D3B66;\n  cursor: pointer;\n}\n\n.checkbox-text {\n  font-size: 0.95rem;\n}\n\n/* Form Actions */\n.form-actions {\n  display: flex;\n  gap: 24px;\n  flex-wrap: wrap;\n  justify-content: center;\n  padding: 24px 0;\n  border-top: 1px solid #e2e8f0;\n}\n\n.action-group {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  min-width: 160px;\n}\n\n.action-description {\n  font-size: 0.875rem;\n  color: #6b7280;\n  text-align: center;\n  margin: 0;\n  line-height: 1.4;\n}\n\n/* Buttons */\n.btn {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 140px;\n  justify-content: center;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n  color: white;\n  box-shadow: 0 4px 8px rgba(102, 126, 234, 0.3);\n  border: 2px solid transparent;\n}\n\n.btn-primary:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);\n}\n\n.btn-outline {\n  background: #ffffff;\n  color: #0D3B66;\n  border: 2px solid #0D3B66;\n  box-shadow: 0 2px 8px rgba(13, 59, 102, 0.2);\n}\n\n.btn-outline:hover:not(:disabled) {\n  background: #0D3B66;\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n}\n\n.btn-warning {\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n  color: white;\n  box-shadow: 0 4px 8px rgba(245, 158, 11, 0.3);\n  border: 2px solid transparent;\n}\n\n.btn-warning:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(245, 158, 11, 0.4);\n}\n\n/* Import Result */\n.import-result {\n  background: #f8fafc;\n  border-radius: 8px;\n  padding: 24px;\n  margin-top: 24px;\n  border-left: 4px solid #e2e8f0;\n}\n\n.import-result.success {\n  border-left-color: #48bb78;\n  background: #f0fff4;\n}\n\n.import-result.error {\n  border-left-color: #f56565;\n  background: #fff5f5;\n}\n\n.result-header h3 {\n  margin: 0 0 8px 0;\n  font-size: 1.3rem;\n  font-weight: 600;\n}\n\n.result-message {\n  margin: 0 0 16px 0;\n  color: #4a5568;\n  font-size: 1rem;\n  line-height: 1.5;\n}\n\n.result-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin: 12px 0;\n  padding: 12px;\n  background: rgba(0, 0, 0, 0.05);\n  border-radius: 6px;\n}\n\n.meta-item {\n  font-size: 0.875rem;\n  color: #6b7280;\n}\n\n.meta-item strong {\n  color: #2d3748;\n}\n\n.preview-note {\n  margin-top: 16px;\n  padding: 12px;\n  background: #e6fffa;\n  border: 1px solid #81e6d9;\n  border-radius: 6px;\n  color: #234e52;\n}\n\n.preview-note p {\n  margin: 0;\n  font-size: 0.875rem;\n}\n\n/* Result Stats */\n.result-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.stat-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 16px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.stat-label {\n  font-size: 0.85rem;\n  color: #718096;\n  margin-bottom: 4px;\n  font-weight: 500;\n}\n\n.stat-value {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #2d3748;\n}\n\n.stat-value.imported {\n  color: #48bb78;\n}\n\n.stat-value.updated {\n  color: #3182ce;\n}\n\n.stat-value.skipped {\n  color: #ed8936;\n}\n\n/* Result Errors */\n.result-errors {\n  margin-top: 20px;\n}\n\n.result-errors h4 {\n  margin: 0 0 12px 0;\n  color: #e53e3e;\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.result-errors ul {\n  margin: 0;\n  padding-left: 20px;\n}\n\n.error-item {\n  color: #c53030;\n  margin-bottom: 8px;\n  font-size: 0.9rem;\n  line-height: 1.4;\n}\n\n/* Result Details */\n.result-details {\n  margin-top: 20px;\n}\n\n.result-details h4 {\n  margin: 0 0 16px 0;\n  color: #2d3748;\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.details-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n}\n\n.detail-item {\n  background: white;\n  padding: 16px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.detail-item h5 {\n  margin: 0 0 12px 0;\n  color: #2d3748;\n  font-size: 1rem;\n  font-weight: 600;\n  text-transform: capitalize;\n}\n\n.detail-stats {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.detail-stat {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 4px 0;\n}\n\n.detail-label {\n  font-size: 0.875rem;\n  color: #6b7280;\n}\n\n.detail-value {\n  font-weight: 600;\n  font-size: 0.875rem;\n}\n\n.detail-value.imported {\n  color: #10b981;\n}\n\n.detail-value.updated {\n  color: #3b82f6;\n}\n\n.detail-value.skipped {\n  color: #f59e0b;\n}\n\n.detail-value.total {\n  color: #6b7280;\n}\n\n.detail-errors {\n  margin-top: 8px;\n  padding: 8px;\n  background: #fef2f2;\n  border-radius: 4px;\n  border: 1px solid #fecaca;\n}\n\n.detail-errors strong {\n  color: #dc2626;\n  font-size: 0.875rem;\n}\n\n.detail-errors ul {\n  margin: 4px 0 0 0;\n  padding-left: 16px;\n}\n\n.detail-error {\n  font-size: 0.8rem;\n  color: #dc2626;\n  margin: 2px 0;\n}\n\n/* Import Info */\n.import-info {\n  background: #f7fafc;\n  padding: 24px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.import-info h3 {\n  margin: 0 0 20px 0;\n  color: #2d3748;\n  font-size: 1.2rem;\n  font-weight: 600;\n}\n\n.info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 24px;\n}\n\n.info-item {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.info-item h4 {\n  margin: 0 0 12px 0;\n  color: #2d3748;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.info-item ul {\n  margin: 0;\n  padding-left: 20px;\n}\n\n.info-item li {\n  margin-bottom: 8px;\n  color: #4a5568;\n  font-size: 0.9rem;\n  line-height: 1.4;\n}\n\n.info-item strong {\n  color: #2d3748;\n  font-weight: 600;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .google-sheets-import {\n    margin: 16px 0;\n  }\n\n  .import-header {\n    padding: 20px;\n  }\n\n  .import-header h2 {\n    font-size: 1.5rem;\n  }\n\n  .import-form-container {\n    padding: 20px;\n  }\n\n  .form-section {\n    padding: 16px;\n  }\n\n  .form-actions {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 16px;\n  }\n\n  .action-group {\n    min-width: auto;\n  }\n\n  .btn {\n    width: 100%;\n    margin-bottom: 8px;\n  }\n\n  .result-stats {\n    grid-template-columns: 1fr;\n  }\n\n  .details-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .info-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .import-header {\n    padding: 16px;\n  }\n\n  .import-form-container {\n    padding: 16px;\n  }\n\n  .form-section {\n    padding: 12px;\n  }\n\n  .import-info {\n    padding: 16px;\n  }\n}\n\n/* Loading States */\n.btn:disabled {\n  position: relative;\n  overflow: hidden;\n}\n\n.btn:disabled::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  animation: loading 1.5s infinite;\n}\n\n@keyframes loading {\n  0% {\n    left: -100%;\n  }\n\n  100% {\n    left: 100%;\n  }\n}\n\n/* Focus States for Accessibility */\n.form-select:focus,\n.checkbox-input:focus,\n.btn:focus {\n  outline: 2px solid #0D3B66;\n  outline-offset: 2px;\n}\n\n/* Print Styles */\n@media print {\n  .google-sheets-import {\n    box-shadow: none;\n    border: 1px solid #e2e8f0;\n  }\n\n  .form-actions {\n    display: none;\n  }\n\n  .import-result {\n    break-inside: avoid;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
